<template>
  <nav class="header-nav">
    <div class="nav-block"></div>
    <div class="header-nav__end">
      <div class="nav-block">
        <router-link class="header-nav__link" to="/" exact> Home </router-link>
        <router-link
          class="header-nav__link"
          to="/networking"
          v-if="currentUser"
        >
          Networking
        </router-link>
        <router-link class="header-nav__link" to="/socials" v-if="currentUser">
          Social Sharing
        </router-link>
        <router-link
          class="header-nav__link"
          to="/resources"
          v-if="currentUser"
        >
          Resources
        </router-link>
        <router-link
          class="header-nav__link"
          to="/chat"
          :class="{ 'chat-active': chatActive }"
          v-if="currentUser"
        >
          Chat
        </router-link>
        <router-link class="header-nav__link" to="/stories" v-if="currentUser">
          Photos & Stories
        </router-link>
        <router-link class="header-nav__link" to="/agenda" v-if="currentUser">
          Agenda
        </router-link>
        <a class="header-nav__link" @click="logout()" v-if="currentUser"
          >Logout</a
        >
      </div>
    </div>
  </nav>
</template>

<script>
export default {
  name: "HeaderNav",
  data() {
    return {
      signInModal: false,
    };
  },
  methods: {
    logout() {
      this.$store.dispatch("auth/logout");
      this.$router.push("/login");
    },
    openAuthModal() {
      this.$root.$emit("auth");
    },
  },
  computed: {
    chatActive() {
      return this.activePage && this.activePage.is_chat_hub;
    },
  },
};
</script>

<style scoped lang="scss">
.header-nav {
  white-space: nowrap;
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 100%;

  &__end {
    display: flex;
    align-items: center;
    height: 100%;
  }

  &__link {
    display: inline-block;
    margin-right: 40px;
    font-size: 16px;
    font-weight: 600;
    text-decoration: none;
    transition: 0.3s;
    border-bottom: 1px solid transparent;

    &.router-link-active {
      border-color: $primary;
    }

    &:not(.router-link-active):hover {
      color: $primary;
    }
  }
}

.chat-active {
  cursor: default;
  pointer-events: none;
  color: $active-link;
}

.v-btn::v-deep {
  &.v-size--default {
    font-weight: 500;
    font-size: 16px !important;
    letter-spacing: 0.1em;
    border-radius: 0;
  }
  &:not(.v-btn--round).v-size--default {
    height: 100%;
    padding: 0 40px;
  }
}

@media screen and (max-width: 960px) {
  .nav-block {
    display: none !important;
  }

  .header-nav__end {
    width: 100%;
    justify-content: flex-end;
  }

  .header-nav {
    display: none;
  }
}
</style>
